import React from 'react';
import './GiftCards.css';
import eventsPoster from '../assets/host next event with us.jpg'; // We'll use this temporarily until you have a gift card specific image

const GiftCards = () => {
  const handlePurchaseClick = () => {
    window.open('https://www.toasttab.com/drakes-san-carlos-1101-san-carlos-avenue/giftcards', '_blank');
  };

  return (
    <div className="gift-cards-container">
      <div className="image-header">
        <img
          src={eventsPoster}
          alt="Drake's Gift Cards"
          className="gift-cards-hero"
        />
      </div>
      
      <div className="gift-cards-content">
        <h1 className="gift-cards-title">Drake's Gift Cards</h1>
        
        <div className="gift-cards-description">
          <p>Give the gift of an exceptional dining experience at Drake's San Carlos. Our gift cards are perfect for:</p>
          <ul>
            <li>Birthday celebrations</li>
            <li>Anniversary gifts</li>
            <li>Corporate rewards</li>
            <li>Thank you gestures</li>
            <li>Special occasions</li>
          </ul>
          <p>Available in any denomination, our digital gift cards can be purchased online and delivered instantly via email.</p>
        </div>

        <button onClick={handlePurchaseClick} className="purchase-button">
          Purchase Gift Cards
        </button>
      </div>
    </div>
  );
};

export default GiftCards; 